module.exports = __webpack_public_path__ + "img/Gallery_3_02.3e7f7c41.jpeg";